import { userApi } from "../store/auth/userapi";
import store from "../store/store";
import { orgApi } from "../store/auth/orgapi";

async function getUser(userid) {
  try {
    const result = await store.dispatch(
      userApi.endpoints.getUser.initiate(userid)
    );
    // RTK Query initiate returns a promise that resolves when the query completes
    // If there's an error or no data, handle it appropriately
    if (result.error) {
      const errorMessage = result.error.data?.message || 
                          result.error.error || 
                          `HTTP ${result.error.status || 'unknown'}`;
      console.error("Error fetching user:", {
        userId: userid,
        status: result.error.status,
        error: result.error,
        message: errorMessage
      });
      throw new Error(`Failed to fetch user details: ${errorMessage}`);
    }
    if (!result.data) {
      throw new Error("User details not found");
    }
    return result.data;
  } catch (error) {
    console.error("Exception in getUser:", error);
    if (error instanceof Error) {
      throw error;
    }
    throw new Error(`Failed to fetch user details: ${error.message || 'Unknown error'}`);
  }
}

async function getUserByOrg(orgid) {
  try {
    const { data, error, isLoading } = await store.dispatch(
      userApi.endpoints.getUserByOrg.initiate(orgid)
    );
    if (!isLoading) {
      if (error) {
        return { error: error.data };
      }
      return data;
    }
  } catch (err) {
    return { error: { text: 'An unexpected error occurred.' } };
  }
}

async function getOrganization(orgid) {
  const { data, isLoading } = await store.dispatch(
    orgApi.endpoints.getOrg.initiate(orgid)
  );
  if (!isLoading) {
    return data;
  }
}


export { getUser, getUserByOrg, getOrganization };
